/* GOPSHOP 2.1 – Effekte: 3D-Neigung, Tag-/Nacht-Modus und Gopa-Reaktionen. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  /* hell ist Standard; 7.21: während Halloween (html.gop-hw) eigener Speicher, damit alle dunkel starten */
  var KEY = document.documentElement.classList.contains('gop-hw') ? 'gopModeHW' : 'gopMode';

  /* ---------- Tag-/Nacht-Modus ---------- */
  function currentTheme() {
    return document.documentElement.classList.contains('gop-light') ? 'light' : 'dark';
  }

  function setTheme(mode, announce) {
    document.documentElement.classList.toggle('gop-light', mode === 'light');
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    if (document.documentElement.classList.contains('gop-hw')) {
      var tc = document.querySelector('meta[name="theme-color"]');
      if (tc) tc.setAttribute('content', mode === 'light' ? '' : '#07040c');
    }
    document.querySelectorAll('[data-gop-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', mode === 'light' ? 'true' : 'false');
    });
    if (announce && window.GopMascot) {
      window.GopMascot.say(mode === 'light' ? window.GopMascot.texts.day : window.GopMascot.texts.night, 2600);
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gop-theme-toggle]');
    if (b) setTheme(currentTheme() === 'light' ? 'dark' : 'light', true);
  });

  /* ---------- 3D-Neigung für Karten ---------- */
  function bindTilt(el, max) {
    if (el.dataset.gopTiltReady) return;
    el.dataset.gopTiltReady = '1';
    var raf = 0;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      var y = (e.clientY - r.top) / r.height;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        el.style.setProperty('--gop-rx', ((0.5 - y) * max).toFixed(2) + 'deg');
        el.style.setProperty('--gop-ry', ((x - 0.5) * max).toFixed(2) + 'deg');
        el.style.setProperty('--gop-mx', (x * 100).toFixed(1) + '%');
        el.style.setProperty('--gop-my', (y * 100).toFixed(1) + '%');
        el.classList.add('is-tilting');
      });
    });
    el.addEventListener('pointerleave', function () {
      cancelAnimationFrame(raf);
      el.classList.remove('is-tilting');
      el.style.removeProperty('--gop-rx');
      el.style.removeProperty('--gop-ry');
    });
  }

  function initTilt(scope) {
    if (reduce || !fine) return;
    (scope || document).querySelectorAll('.card-wrapper .card, [data-gop-tilt], gop-category-grid .gpc__card').forEach(function (el) {
      bindTilt(el, el.hasAttribute('data-gop-tilt') ? 14 : 9);
    });
  }

  /* ---------- Gopa-Reaktionen ---------- */
  function initMascot() {
    var G = window.GopMascot;
    if (!G) return;
    var root = G.root;
    var img = root.querySelector('.gop-mascot__toggle img');
    var once = {};
    /* Fußbereich im Bild → keine Sprechblase (sie würde Kontakt/Rechtliches verdecken) */
    var footIn = false;
    var foot = document.querySelector('footer.footer');
    if (foot && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { footIn = en[0].isIntersecting; }).observe(foot);
    }
    G.quiet = function () { return footIn; };
    function sayOnce(key, text, ms) {
      if (once[key] || footIn || root.classList.contains('is-open') || (G.quiet && G.quiet())) return;
      try { if (sessionStorage.getItem('gop-said-' + key)) return; sessionStorage.setItem('gop-said-' + key, '1'); } catch (e) {}
      once[key] = true;
      G.say(text, ms);
    }

    // Müde werden, wenn lange nichts passiert
    var idleTimer;
    function resetIdle() {
      root.classList.remove('is-sleepy');
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        root.classList.add('is-sleepy');
        sayOnce('idle', G.texts.idle, 4200);
      }, 40000);
    }
    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (ev) {
      window.addEventListener(ev, resetIdle, { passive: true });
    });
    resetIdle();

    /* Ausweichen: liegt ein bedienbares Element (Mystery-Wahl, FAQ-Knopf, Fußbereich …) unten rechts
       hinter dem Knopf, blendet Gopa kurz aus (.is-dodge, gop-light.css). Beobachtet nur den Streifen unten rechts. */
    /* Handy: Gopa erst einblenden, wenn die Story-Kreise oben aus dem Bild sind (kein Verdecken des Hero/der Stories) */
    var early = document.querySelector('.gst, [data-gop-stories]');
    if (early && 'IntersectionObserver' in window && document.body.classList.contains('template-index')) {
      root.classList.add('is-early');
      new IntersectionObserver(function (en) {
        var e = en[0];
        root.classList.toggle('is-early', e.isIntersecting || e.boundingClientRect.top > 0);
      }).observe(early);
    }
    /* Anfrage-Formular im Bild → weder Knopf noch Blase darüber (Handy) */
    var wishSec = document.querySelector('#gop-wish, .gop-wish');
    var wishIn = false;
    if (wishSec && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        wishIn = en[0].isIntersecting;
        root.classList.toggle('is-wish', wishIn && window.innerWidth < 750);
      }, { rootMargin: '0px 0px -20% 0px' }).observe(wishSec);
    }
    var quietBase = G.quiet;
    G.quiet = function () { return (quietBase && quietBase()) || (wishIn && window.innerWidth < 750); };
    var DODGE = '.gmc__card, .gmc__tile, .gmc__detail, .gop-faq__item, .gop-steps__contact, .gop-foot, .footer__content-bottom, .gop-delivery__note, .gop-wish .gop-btn, .gop-wish .gw__input, .gop-wish .gw__money-in';
    var dodgeIo = null;
    var dodgeHits = new Set();
    function dodgeSetup() {
      if (!('IntersectionObserver' in window)) return;
      if (dodgeIo) dodgeIo.disconnect();
      dodgeHits.clear();
      root.classList.remove('is-dodge');
      var band = 104;
      dodgeIo = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) dodgeHits.add(e.target); else dodgeHits.delete(e.target); });
        root.classList.toggle('is-dodge', dodgeHits.size > 0);
      }, { rootMargin: '-' + Math.max(0, window.innerHeight - band) + 'px 0px 0px -60%' });
      /* Desktop: nur der Fußbereich; am Handy alle bedienbaren Bereiche */
      document.querySelectorAll(window.innerWidth < 750 ? DODGE : '.gop-foot, .footer__content-bottom').forEach(function (el) { dodgeIo.observe(el); });
    }
    dodgeSetup();
    var dodgeW = window.innerWidth, dodgeH = window.innerHeight, dodgeT;
    window.addEventListener('resize', function () {
      if (window.innerWidth === dodgeW && Math.abs(window.innerHeight - dodgeH) < 120) return;
      dodgeW = window.innerWidth;
      dodgeH = window.innerHeight;
      clearTimeout(dodgeT);
      dodgeT = setTimeout(dodgeSetup, 250);
    });

    // Maus verlässt oben die Seite (nur Desktop)
    if (fine) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) sayOnce('leave', G.texts.leave, 4500);
      });
    }

    // Kopf folgt dem Zeiger ein wenig
    if (fine && !reduce && img) {
      window.addEventListener('pointermove', function (e) {
        var r = root.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        var a = Math.max(-12, Math.min(12, dx / 40));
        var t = Math.max(-6, Math.min(6, dy / 60));
        root.style.setProperty('--gop-look', a.toFixed(1) + 'deg');
        root.style.setProperty('--gop-look-y', t.toFixed(1) + 'px');
      }, { passive: true });
    }

    // Wunschprodukt verschickt
    /* Keine Blase (sie lag über „Weiteres Produkt anfragen“) – Gopa freut sich nur kurz; die Bestätigung zeigt das Formular selbst */
    document.addEventListener('gop:wish-sent', function () {
      root.classList.remove('is-happy');
      void root.offsetWidth;
      root.classList.add('is-happy');
      setTimeout(function () { root.classList.remove('is-happy'); }, 1800);
    });
  }

  /* ---------- Scroll-Animationen: Elemente gleiten nacheinander herein ---------- */
  var REVEAL = '[data-gop-reveal], .gpc__item, .gop-step, .gop-faq__item, .card-wrapper, .gop-section__head, .gop-spot__stage, .gop-spot__content, .gop-wish__form';
  var io = null;
  function initReveal(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var el = en.target;
            el.classList.add('is-in');
            io.unobserve(el);
            // Nach der Animation aufräumen, damit Hover-Effekte wieder greifen
            var i = parseInt(el.style.getPropertyValue('--gop-i'), 10) || 0;
            setTimeout(function () { el.classList.remove('gop-rv', 'is-in'); el.dataset.gopRevealed = '1'; }, 1000 + i * 90);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    (scope || document).querySelectorAll(REVEAL).forEach(function (el) {
      if (el.classList.contains('gop-rv') || el.dataset.gopRevealed) return;
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--gop-i', Math.min(sib, 8));
      el.classList.add('gop-rv');
      io.observe(el);
    });
  }

  /* ---------- Gopa im Hero: Antippen = Freudensprung, 5x schnell = Geheimnis ---------- */
  var taps = [];
  document.addEventListener('click', function (e) {
    var g = e.target.closest('[data-gop-gopa]');
    if (!g) return;
    g.classList.remove('is-happy');
    void g.offsetWidth;
    g.classList.add('is-happy');
    var now = performance.now();
    taps = taps.filter(function (t) { return now - t < 2500; });
    taps.push(now);
    if (taps.length >= 5) {
      taps = [];
      confetti();
      if (window.GopMascot) {
        window.GopMascot.cheer();
        window.GopMascot.say(window.GopMascot.texts.secret || '🎉', 4200);
      }
    } else if (window.GopMascot) {
      window.GopMascot.say(window.GopMascot.texts.teaser, 2800);
    }
  });

  /* ---------- Konfetti in Markenfarben (für das Geheimnis) ---------- */
  function confetti() {
    if (reduce) return;
    var c = document.createElement('canvas');
    c.className = 'gop-confetti';
    document.body.appendChild(c);
    var ctx = c.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    c.width = innerWidth * dpr;
    c.height = innerHeight * dpr;
    ctx.scale(dpr, dpr);
    var colors = ['#38f9dc', '#7ffff0', '#19c9ae', '#ffffff', '#ffd76a'];
    var parts = [];
    for (var i = 0; i < 160; i++) {
      parts.push({
        x: innerWidth / 2 + (Math.random() - 0.5) * 120,
        y: innerHeight * 0.55,
        vx: (Math.random() - 0.5) * 16,
        vy: -8 - Math.random() * 14,
        r: 3 + Math.random() * 5,
        a: Math.random() * Math.PI,
        va: (Math.random() - 0.5) * 0.4,
        c: colors[i % colors.length],
        d: Math.random() < 0.3
      });
    }
    var start = performance.now();
    (function frame(t) {
      var k = (t - start) / 1000;
      ctx.clearRect(0, 0, innerWidth, innerHeight);
      parts.forEach(function (p) {
        p.vy += 0.45;
        p.vx *= 0.99;
        p.x += p.vx;
        p.y += p.vy;
        p.a += p.va;
        ctx.save();
        ctx.globalAlpha = Math.max(0, 1 - k / 3.2);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.a);
        ctx.fillStyle = p.c;
        if (p.d) {
          ctx.beginPath();
          ctx.moveTo(0, -p.r * 1.4);
          ctx.lineTo(p.r, 0);
          ctx.lineTo(0, p.r * 1.4);
          ctx.lineTo(-p.r, 0);
          ctx.closePath();
          ctx.fill();
        } else {
          ctx.fillRect(-p.r, -p.r / 2, p.r * 2, p.r);
        }
        ctx.restore();
      });
      if (k < 3.3) requestAnimationFrame(frame);
      else c.remove();
    })(start);
  }

  /* ---------- Scroll-Fortschritt (schmale Linie, ohne Symbol) ---------- */
  function initProgress() {
    if (document.querySelector('.gop-progressbar')) return;
    var bar = document.createElement('div');
    bar.className = 'gop-progressbar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span class="gop-progressbar__fill"></span>';
    document.body.appendChild(bar);
    var ticking = false;
    var max = 0;
    var dirty = true;
    function measure() {
      dirty = true;
    }
    /* Höhe erst beim Scrollen messen und nur, wenn sie sich geändert hat (kein erzwungenes Layout beim Laden) */
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(document.body);
    function update() {
      ticking = false;
      if (dirty) {
        dirty = false;
        max = document.documentElement.scrollHeight - innerHeight;
      }
      var v = max > 0 ? Math.min(1, Math.max(0, scrollY / max)) : 0;
      bar.style.setProperty('--gop-scroll', v.toFixed(4));
    }
    addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    addEventListener('resize', measure);
  }

  /* ---------- Desktop: leuchtender Cursor + magnetische Buttons ---------- */
  function initDesktopFx() {
    if (!fine || reduce) return;
    var glow = document.createElement('div');
    glow.className = 'gop-cursor-glow';
    glow.setAttribute('aria-hidden', 'true');
    document.body.appendChild(glow);
    var raf = 0, cx = 0, cy = 0;
    addEventListener('pointermove', function (e) {
      cx = e.clientX; cy = e.clientY;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        glow.style.setProperty('--gop-cx', cx + 'px');
        glow.style.setProperty('--gop-cy', cy + 'px');
      });
    }, { passive: true });

    document.addEventListener('pointermove', function (e) {
      var b = e.target.closest && e.target.closest('.gop-btn');
      if (!b) return;
      var r = b.getBoundingClientRect();
      var x = (e.clientX - (r.left + r.width / 2)) / r.width;
      var y = (e.clientY - (r.top + r.height / 2)) / r.height;
      b.style.translate = (x * 8).toFixed(1) + 'px ' + (y * 6).toFixed(1) + 'px';
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var b = e.target.closest && e.target.closest('.gop-btn');
      if (b && !b.contains(e.relatedTarget)) b.style.translate = '';
    });
  }


  /* ---------- Hero: Überschrift erscheint Wort für Wort, danach wechselt das fette Wort (Scramble) ---------- */
  function initHeroWords() {
    document.querySelectorAll('.gop-hero').forEach(function (hero) {
      if (hero.dataset.gopIntro) return;
      hero.dataset.gopIntro = '1';
      var title = hero.querySelector('.gop-hero__title');
      if (!title) return;
      if (!reduce) {
        hero.classList.add('is-intro');
        var i = 0;
        var walk = function (node) {
          Array.prototype.slice.call(node.childNodes).forEach(function (n) {
            if (n.nodeType === 3) {
              var frag = document.createDocumentFragment();
              n.textContent.split(/(\s+)/).forEach(function (part) {
                if (!part) return;
                if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
                var w = document.createElement('span');
                w.className = 'gop-w';
                w.style.setProperty('--i', i++);
                w.textContent = part;
                frag.appendChild(w);
              });
              n.parentNode.replaceChild(frag, n);
            } else if (n.nodeType === 1 && n.tagName !== 'STRONG' && n.tagName !== 'EM') {
              walk(n);
            } else if (n.nodeType === 1) {
              n.classList.add('gop-w');
              n.style.setProperty('--i', i++);
            }
          });
        };
        walk(title);
        title.classList.add('is-in');
      }
      var list = (title.getAttribute('data-gop-words') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
      var strong = title.querySelector('strong, em');
      if (!strong || !list.length || reduce) return;
      strong.setAttribute('data-gop-word', '');
      var first = strong.textContent.trim();
      var words = [first].concat(list.filter(function (w) { return w !== first; }));
      var idx = 0;
      var gopa = hero.querySelector('.gop-gopa--rig');
      /* Stabiles Layout: Wort + folgendes Satzzeichen in eine Box fester Breite
         (breitestes Wort) – so bricht die Zeile nie um, und die Titelhöhe wird
         auf die höchste Variante fixiert. Gopa (andere Spalte) bleibt ruhig. */
      // Höhe vor dem Umbau merken: der Titel wird beim ersten Messen nie kleiner (kein CLS beim Laden)
      var initH = title.getBoundingClientRect().height;
      var keepInit = true;
      var box = document.createElement('span');
      box.className = 'gop-hero__wordbox';
      strong.parentNode.insertBefore(box, strong);
      box.appendChild(strong);
      var nx = box.nextSibling;
      if (nx && nx.nodeType === 1 && /^[.,!?:;…]+$/.test(nx.textContent.trim())) box.appendChild(nx);
      else if (nx && nx.nodeType === 3 && /^[.,!?:;…]/.test(nx.textContent)) {
        var m = nx.textContent.match(/^[.,!?:;…]+/)[0];
        nx.textContent = nx.textContent.slice(m.length);
        box.appendChild(document.createTextNode(m));
      }
      var busy = false, pending = false;
      var measure = function () {
        if (busy) { pending = true; return; }
        var cur = strong.textContent;
        box.style.width = '';
        box.style.height = '';
        title.style.minHeight = '';
        box.classList.remove('is-wrap');
        var maxW = 0;
        words.forEach(function (w) { strong.textContent = w; maxW = Math.max(maxW, strong.getBoundingClientRect().width); });
        var titleW = title.clientWidth;
        var extra = box.getBoundingClientRect().width - strong.getBoundingClientRect().width;
        var boxW = Math.ceil(maxW + extra + 2);
        if (boxW > titleW) { boxW = titleW; box.classList.add('is-wrap'); }
        box.style.width = boxW + 'px';
        var maxH = 0, maxB = 0;
        words.forEach(function (w) {
          strong.textContent = w;
          maxH = Math.max(maxH, title.getBoundingClientRect().height);
          maxB = Math.max(maxB, box.getBoundingClientRect().height);
        });
        strong.textContent = cur;
        // feste Box-Höhe: der Wechsel ändert die Zeilenzahl nie
        box.style.height = Math.ceil(maxB) + 'px';
        title.style.minHeight = Math.ceil(keepInit ? Math.max(maxH, initH) : maxH) + 'px';
      };
      measure();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
      var rt, lastW = window.innerWidth;
      window.addEventListener('resize', function () {
        if (window.innerWidth === lastW) return; // mobile URL-Leiste: nur echte Breitenänderung
        lastW = window.innerWidth;
        keepInit = false;
        clearTimeout(rt);
        rt = setTimeout(measure, 150);
      });

      /* Ruhiger Wechsel: altes Wort gleitet nach oben weg, neues gleitet von unten ein.
         Die Box hat feste Breite/Höhe (measure) → kein Zeilen- oder Layoutsprung. */
      var swap = function (to) {
        busy = true;
        strong.style.animation = 'none';
        strong.classList.add('is-leave');
        setTimeout(function () {
          strong.textContent = to;
          strong.classList.remove('is-leave');
          strong.classList.add('is-enter');
          void strong.offsetWidth;
          strong.classList.remove('is-enter');
          setTimeout(function () {
            busy = false;
            if (pending) { pending = false; measure(); }
          }, 420);
        }, 200);
      };
      var visible = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(hero);
      }
      setInterval(function () {
        if (!visible || document.hidden) return;
        idx = (idx + 1) % words.length;
        swap(words[idx]);
        if (gopa) {
          gopa.classList.remove('is-point');
          void gopa.offsetWidth;
          gopa.classList.add('is-point');
          setTimeout(function () { gopa.classList.remove('is-point'); }, 1700);
        }
      }, 3200);
    });
  }

  /* ---------- Hero: „Welches Produkt suchst du?“ → Anfrage-Formular vorbefüllen ---------- */
  function initHeroAsk() {
    document.querySelectorAll('[data-gop-hero-ask]').forEach(function (f) {
      if (f.__ask) return;
      f.__ask = true;
      /* Schmale Bildschirme: kurzer Platzhalter, sonst wird er abgeschnitten */
      var inpEl = f.querySelector('input[name="wish"]');
      if (inpEl && inpEl.dataset.phShort) {
        var full = inpEl.getAttribute('placeholder');
        var mq = window.matchMedia('(max-width: 479px)');
        var setPh = function () { inpEl.setAttribute('placeholder', mq.matches ? inpEl.dataset.phShort : full); };
        setPh();
        if (mq.addEventListener) mq.addEventListener('change', setPh);
      }
      f.addEventListener('submit', function (e) {
        var inp = f.querySelector('input[name="wish"]');
        var what = inp ? inp.value.trim() : '';
        var W = window.gopWish;
        e.preventDefault();
        if (W) {
          /* API von B: füllt vor, scrollt genau einmal, Fokus danach in „Größe / Farbe“ */
          if (what) W.prefill({ what: what }, { focus: true }); else W.open();
          return;
        }
        var base = f.getAttribute('action') || '/';
        location.href = what ? base + '?wish=' + encodeURIComponent(what) + '&wish_focus=1#gop-wish' : base + '#gop-wish';
      });
    });
  }

  function boot() {
    initHeroAsk();
    setTheme(currentTheme(), false);
    initReveal();
    initTilt();
    initMascot();
    initProgress();
    initDesktopFx();
    initHeroWords();
    // Neue Produktkarten (Filter, Nachladen) automatisch mitnehmen
    if ('MutationObserver' in window && !reduce) {
      var t;
      var NEW = '.card-wrapper, [data-gop-reveal]';
      new MutationObserver(function (muts) {
        var hit = false;
        for (var i = 0; i < muts.length && !hit; i++) {
          var a = muts[i].addedNodes;
          for (var j = 0; j < a.length; j++) {
            var n = a[j];
            if (n.nodeType === 1 && !n.closest('[data-gop-sprint], [data-p3d-stage]') && (n.matches(NEW) || n.querySelector(NEW))) {
              hit = true;
              break;
            }
          }
        }
        if (!hit) return;
        clearTimeout(t);
        t = setTimeout(function () { initTilt(); initReveal(); }, 200);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { initTilt(e.target); initReveal(e.target); });
})();
